import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#gw7fc9te5a)" }, [
      _createElementVNode("path", {
        d: "M23.5 21H3V.5a.5.5 0 0 0-1 0V21H.5a.5.5 0 0 0 0 1H2v1.5a.5.5 0 0 0 1 0V22h20.5a.5.5 0 0 0 0-1zM4.499 20a.5.5 0 0 0 .391-.187l3.651-4.564 1.605 1.605a.5.5 0 0 0 .783-.096l2.63-4.383 1.551 1.938a.501.501 0 0 0 .88-.209l1.81-8.597 2.347 2.347A.503.503 0 0 0 20.9 7.8l3-4a.5.5 0 1 0-.8-.6l-2.656 3.539-2.592-2.592a.499.499 0 0 0-.843.25l-1.782 8.464-1.338-1.673a.521.521 0 0 0-.424-.187.504.504 0 0 0-.395.242l-2.67 4.451-1.547-1.547a.502.502 0 0 0-.744.041l-4 5a.501.501 0 0 0 .39.812z",
        fill: "#000",
        "fill-opacity": ".87"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "gw7fc9te5a" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M0 0h24v24H0z"
        })
      ])
    ], -1)
  ])))
}
export default { render: render }